<div class="sm:py-8">
  <div class="mx-auto max-w-7xl px-2 lg:px-2">
    <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
      <h1 class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">ParkraumPlus - die effiziente Lösung</h1>
      <div class="mt-10 grid max-w-xl grid-cols-2 text-base leading-7 text-gray-700 lg:max-w-none lg:grid-cols-4">
        <div *ngIf="canSeeTransfer">
          <p>
            <img src="../../assets/btn-transfer.png" />
          </p>
          <a
            [href]="['/transfer']"
            class="bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >Transfer</a
          >
        </div>
        <div *ngIf="canSeeMandate">
          <p>
            <img src="../../assets/btn-mandate.png" />
          </p>
          <a
            [href]="['/mandate']"
            class="bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >Mandate</a
          >
        </div>

        <div *ngIf="canSeeZahlung">
          <p>
            <img src="../../assets/btn-zahlung.png" />
          </p>
          <a
            [href]="['/zahlungsabgleich']"
            class="bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >Zahlungsabgleich</a
          >
        </div>

        <div *ngIf="canSeeVstv">
          <p>
            <img src="../../assets/btn-vstv.png" />
          </p>
          <a
            [href]="['/vstv']"
            class="bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >VSTV Export</a
          >
        </div>
      </div>

      <div *ngIf="isSuperuser" class="mt-12">
        <h2 class="text-xl font-semibold text-gray-900 mb-4">Systemübersicht</h2>

        <div *ngIf="loadingStats" class="text-sm text-gray-500">Laden...</div>
        <div *ngIf="statsError" class="text-sm text-red-600 mb-4">{{ statsError }}</div>

        <div *ngIf="stats" class="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
          <div class="stat-card rounded-lg border border-gray-200 bg-white shadow-sm">
            <div class="stat-card__header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2.5"
                stroke="currentColor"
                class="stat-card__icon"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <p class="stat-card__label">Transfers gesamt {{ stats.counts.year }}</p>
            </div>
            <p class="stat-card__hero">{{ stats.counts.transfers.year | number }}</p>
            <p class="stat-card__total">
              <span class="stat-card__total-value">{{ stats.counts.transfers.total | number }}</span>
              <span class="stat-card__total-label">insgesamt</span>
            </p>
          </div>
          <div class="stat-card rounded-lg border border-gray-200 bg-white shadow-sm">
            <div class="stat-card__header">
              <svg
                aria-hidden="true"
                class="stat-card__icon stat-card__icon--filled"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                  clip-rule="evenodd"
                />
              </svg>
              <p class="stat-card__label">Mandate gesamt {{ stats.counts.year }}</p>
            </div>
            <p class="stat-card__hero">{{ stats.counts.mandate.year | number }}</p>
            <p class="stat-card__total">
              <span class="stat-card__total-value">{{ stats.counts.mandate.total | number }}</span>
              <span class="stat-card__total-label">insgesamt</span>
            </p>
          </div>
          <div class="stat-card rounded-lg border border-gray-200 bg-white shadow-sm">
            <div class="stat-card__header">
              <svg
                aria-hidden="true"
                class="stat-card__icon stat-card__icon--filled"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"
                />
                <path
                  d="M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
                />
              </svg>
              <p class="stat-card__label">VSTV-Exporte gesamt {{ stats.counts.year }}</p>
            </div>
            <p class="stat-card__hero">{{ stats.counts.vstv_exports.year | number }}</p>
            <p class="stat-card__total">
              <span class="stat-card__total-value">{{ stats.counts.vstv_exports.total | number }}</span>
              <span class="stat-card__total-label">insgesamt</span>
            </p>
          </div>
        </div>

        <div *ngIf="stats" class="space-y-8">
          <div>
            <h3 class="text-lg font-semibold text-gray-900 mb-3">Aktive Web-Benutzer</h3>
            <div class="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm">
              <table class="min-w-full text-sm">
                <thead class="bg-gray-50 text-left text-gray-600">
                  <tr>
                    <th class="px-4 py-2 font-medium">Name</th>
                    <th class="px-4 py-2 font-medium">Login</th>
                    <th class="px-4 py-2 font-medium">Rolle</th>
                    <th class="px-4 py-2 font-medium">Dienstnehmer</th>
                    <th class="px-4 py-2 font-medium">Letzter Login</th>
                    <th class="px-4 py-2 font-medium">IP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of stats.users" class="border-t border-gray-100">
                    <td class="px-4 py-2">{{ user.name }}</td>
                    <td class="px-4 py-2">{{ user.login }}</td>
                    <td class="px-4 py-2">
                      <span class="inline-block rounded px-2 py-0.5 text-xs font-medium" [ngClass]="roleClasses(user.role_id)">
                        {{ user.role_name }}
                      </span>
                    </td>
                    <td class="px-4 py-2">{{ user.dienstnehmer_name || '–' }}</td>
                    <td class="px-4 py-2">{{ user.lastlogin || '–' }}</td>
                    <td class="px-4 py-2">{{ user.lastip || '–' }}</td>
                  </tr>
                  <tr *ngIf="stats.users.length === 0">
                    <td colspan="6" class="px-4 py-4 text-gray-500">Keine aktiven Benutzer gefunden.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div>
            <h3 class="text-lg font-semibold text-gray-900 mb-1">Aktive Dienstnehmer</h3>
            <p class="mb-3 text-sm text-gray-500">
              Organisationen / Beamte für die Mobile-App (z.&nbsp;B. Überwachungsorgane).
            </p>
            <div class="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm">
              <table class="min-w-full text-sm">
                <thead class="bg-gray-50 text-left text-gray-600">
                  <tr>
                    <th class="px-4 py-2 font-medium">Name</th>
                    <th class="px-4 py-2 font-medium">Dienstnr.</th>
                    <th class="px-4 py-2 font-medium">STVO</th>
                    <th class="px-4 py-2 font-medium">Gruppe</th>
                    <th class="px-4 py-2 font-medium">Sachbereich</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dn of stats.dienstnehmer" class="border-t border-gray-100">
                    <td class="px-4 py-2 font-medium text-gray-900">{{ dn.name }}</td>
                    <td class="px-4 py-2">{{ dn.dienstnummer }}</td>
                    <td class="px-4 py-2">{{ dn.dienstnummer_stvo }}</td>
                    <td class="px-4 py-2">
                      <span class="inline-block rounded px-2 py-0.5 text-xs font-medium" [ngClass]="roleClasses(dn.role_id)">
                        {{ roleLabel(dn.role_id) }}
                      </span>
                    </td>
                    <td class="px-4 py-2">{{ dn.sachbereich || '–' }}</td>
                  </tr>
                  <tr *ngIf="stats.dienstnehmer.length === 0">
                    <td colspan="5" class="px-4 py-4 text-gray-500">Keine aktiven Dienstnehmer gefunden.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
